<template>
  <el-popover
    placement="right-start"
    trigger="hover"
    width="640"
    :open-delay="50"
    :visible-arrow="false"
    :title="$t('samples.sampleDescriptionHelp')"
    popper-class="sample-description-help__popper"
  >
    <div class="sample-description-help__scroll">
      <table class="sample-description-help__table">
        <thead>
          <tr>
            <th
              v-for="productType in productTypes"
              :key="productType"
            >
              {{ $t(`samples.productTypes.${productType}`) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, rowIndex) in rows"
            :key="rowIndex"
          >
            <td
              v-for="(value, columnIndex) in row"
              :key="columnIndex"
            >
              {{ value ? $t(`samples.sampleDescriptions.${value}`) : '' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <i
      slot="reference"
      class="fas fa-question info-tooltip__icon sample-description-help__icon"
    />
  </el-popover>
</template>

<script>
import sampleDescriptionsByProductType from '@/config/sampleDescriptionsByProductType';

export default {
  name: 'SampleDescriptionHelp',
  computed: {
    productTypes() {
      return Object.keys(sampleDescriptionsByProductType);
    },
    // One row per table line, padded with null so the shorter columns keep
    // their cells aligned under the right heading.
    rows() {
      const columns = Object.values(sampleDescriptionsByProductType);
      const rowCount = Math.max(...columns.map(column => column.length));

      return Array.from(
        { length: rowCount },
        (unused, rowIndex) => columns.map(column => column[rowIndex] || null),
      );
    },
  },
};
</script>

<style lang="scss">
// Not scoped: the popper is appended to <body>, out of reach of scoped styles.
.sample-description-help {
  &__icon {
    background-color: $--color-primary;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;

    &:hover {
      background-color: $--color-primary-light-2;
    }
  }

  &__scroll {
    border: 1px solid $--color-primary;
    max-height: 60vh;
    overflow-y: auto;
  }

  &__table {
    background-color: $--color-white;
    border-collapse: collapse;
    font-size: 13px;
    line-height: 1.35;
    table-layout: fixed;
    width: 100%;

    th,
    td {
      padding: 6px 14px;
      text-align: left;
      vertical-align: top;
      width: 33.33%;
      word-break: break-word;
    }

    th {
      background-color: $--color-white;
      box-shadow: inset 0 -2px 0 $--color-primary;
      color: $--color-primary;
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.08em;
      padding-bottom: 12px;
      position: sticky;
      text-transform: uppercase;
      top: 0;
      z-index: 1;
    }

    td {
      border-bottom: 1px solid $--border-color-extra-light;
      color: $--color-text-regular;
    }

    tbody tr:first-child td {
      padding-top: 12px;
    }

    tbody tr:last-child td {
      border-bottom: 0;
    }

    tbody tr:nth-child(even) {
      background-color: $--background-color-base;
    }
  }
}

.sample-description-help__popper.el-popover {
  background-color: $--color-white;
  border: 2px solid $--border-color-base;
  border-radius: 6px;
  max-width: 92vw;
  padding: 32px;

  .el-popover__title {
    color: $--color-text-primary;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 14px;
    padding: 0;
  }
}
</style>
